export const roleDetailsCreate = [
  {
    target: ".j_r_bBtn",
    content: "Click this to go back to roles table.",
    placement: "bottom",
  },
  {
    target: ".j_r_name",
    content: "Enter a unique name for the new role you are creating.",
    placement: "bottom",
  },
  {
    target: ".j_r_dim",
    content:
      "Select a Dimension (e.g., Business Unit) that this role applies to.",
    placement: "bottom",
  },
  {
    target: ".j_r_wt",
    content:
      "Adjust the slider to set the Role's Access Weight (e.g., Power User).",
    placement: "left",
  },
  {
    target: ".r_desc",
    content: "Enter a meaningful description of what this role represents.",
    placement: "bottom",
  },
  {
    target: ".j_r_notes",
    content: "Add any notes relevant to this role for future reference.",
    placement: "bottom",
  },
  {
    target: ".j_r_sel",
    content:
      "Define the selection criteria by specifying the column, operator, and value. You can add multiple conditions.",
    placement: "top",
  },
  {
    target: ".j_r_save",
    content: "Click here to save the role and return to the role list.",
    placement: "left",
  },
];